module.exports = __webpack_public_path__ + "img/29b7266.jpg";